import { Avatar, Typography } from "@/components";
import { formatHumanReadableDate } from "@/libraries/date";
import type { LastMessageType, User } from "@/types";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Suspense, lazy } from "react";

const MarkdownMessage = lazy(
	() => import("@/components/ui/message/item/MarkdownMessage"),
);

interface ChatItemProps {
	type: "group" | "single";
	status?: User["status"];
	title: string;
	avatar?: string | null;
	unread: number;
	lastMessage: LastMessageType | null;
}

const ChatItem = (props: ChatItemProps) => {
	const { type, status, title, avatar, unread, lastMessage } = props;
	return (
		<Card
			variant="outlined"
			className="!h-full !w-full !py-2 !px-3 !rounded-xl bg-white"
		>
			<CardContent className="!p-0 !h-full flex flex-row justify-center items-start gap-3">
				<Avatar
					status={type === "single" ? status : undefined}
					className="!bg-gray-light !text-dark !w-12 !h-12"
					alt={title}
					src={avatar ?? "/images/blanks-avatar.png"}
				/>
				<div className="flex flex-1 flex-col justify-center items-start gap-1">
					<Typography fontWeight={500} fontSize={14}>
						{title}
					</Typography>
					{lastMessage ? (
						<Suspense>
							<MarkdownMessage
								variant="chats"
								text={lastMessage.text}
								isStrike={lastMessage.strike}
								isDeleted={lastMessage.is_deleted}
								lineClamp={1}
								documentCount={lastMessage.document_count}
							/>
						</Suspense>
					) : (
						"No messages"
					)}
				</div>
				<div className="flex flex-col justify-center items-end gap-1">
					{lastMessage ? (
						<Typography fontWeight={400} fontSize={10}>
							{formatHumanReadableDate(lastMessage.created_at)}
						</Typography>
					) : null}
					{unread ? (
						<Typography
							fontWeight={500}
							fontSize={12}
							align="center"
							className="flex-none w-7 bg-secondary px-1 py-1 rounded-full"
						>
							{unread}
						</Typography>
					) : null}
				</div>
			</CardContent>
		</Card>
	);
};

export default ChatItem;
